import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { AdminState } from './state';
import { Report } from '@/interfaces/report';

const defaultState: AdminState = {
  users: [],
  companyReports: null,
  company_id: null,
};

export const adminModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};

export interface Company {
  id: number;
  name: string;
  created_at: Date;
}

export interface CompanyReports {
  company: Company,
  reports: Report[];
  report_count: number;
}

export interface ReportRow {
  company_created_at: string;
  company_name: string;
  report_created_at: string;
  report_id: number;
  result_uploaded: boolean | null;
  result_completed_at: Date | null;
  reenter_request: boolean | null,
  reports: Report[];
  company: Company;
}

export interface UserRow {
  company_created_at: string;
  company_name: string;
  user_name: string;
  user_email: string;
  status: string
  company: Company;
}